import styled from 'styled-components';

export const CarouselContent = styled.div`
    .ant-image {
        width: 100%;
    }
`;
